/** 批量新增转化的应用列表KEY */
module.exports = () => {
  return [
    { name: '分包广告商户ID', value: 'pack_ad_account', overflow: false, align: 'center' },
    { name: '应用ID', value: 'app_id', overflow: false, align: 'center' },
    { name: '应用名称', value: 'app_name', overflow: false, align: 'center' },
  ];
};
